export default __webpack_public_path__ + "static/media/bar.562c29f4.webp";